import { employeeActivityReportList, employeeProductivityReportList, industrialReportList, planningReportList, usersSystemReportList, masterChangeLogReportList, employeeEfficiencyReportList} from "constants/reports";

const initialState = {
  employeeActivityReportList: {},
  employeeProductivityReportList: {},
  industrialReportList: {},
  planningReportList: {},
  usersSystemReportList: {},
  masterChangeLogReportList: {},
  employeeEfficiencyReportList: {},
};

const employeeActivityReport = (state = initialState, action) => {
  switch (action.type) {
    case employeeActivityReportList:
      return { ...state, employeeActivityReportList: action.payload };

    case employeeProductivityReportList:
      return { ...state, employeeProductivityReportList: action.payload };

    case industrialReportList:
      return { ...state, industrialReportList: action.payload };

    case planningReportList:
      return { ...state, planningReportList: action.payload };

    case usersSystemReportList:
      return { ...state, usersSystemReportList: action.payload };

    case masterChangeLogReportList:
      return { ...state, masterChangeLogReportList: action.payload };

    case employeeEfficiencyReportList:
      return { ...state, employeeEfficiencyReportList: action.payload}

    default:
      return state;
  }
};
export default employeeActivityReport;